import { Button } from "src/components/ui/button";
import type { MouseEventHandler } from "react";
import { useFormContext, useWatch } from "react-hook-form";

type SubmitObservationsFormButtonProps = {
	onClick?: MouseEventHandler<HTMLButtonElement> | undefined;

	visibleQuestions: ObservationQuestion[];
};

const SubmitObservationsFormButton = ({
	onClick,
	visibleQuestions
}: SubmitObservationsFormButtonProps) => {
	const { control } = useFormContext<ObservationFormState>();

	const isSubmittingAnswer = useWatch({
		control,
		name: "isSubmittingAnswer"
	});

	const questions = useWatch({
		control,
		name: "questions"
	});

	const isSubmitBtnDisabled = () => {
		if (isSubmittingAnswer && isSubmittingAnswer.length > 0) {
			return true; // Disable the button if answers are being submitted
		}

		const isQuestionsArrayEmpty = !questions || questions?.length === 0;
		const isVisibleQuestionsArrayEmpty =
			!visibleQuestions || visibleQuestions?.length === 0;

		if (isQuestionsArrayEmpty || isVisibleQuestionsArrayEmpty) {
			return true;
		}

		const questionIdsNotAnswered = questions
			.filter((question) => {
				// Skip heading type questions
				if (question.questionType === "HEADING") {
					return false;
				}

				if (question.questionType === "IMAGE_UPLOAD") {
					// For image upload questions, check if images array exists and has items
					return !question.images || question.images.length === 0;
				}
				// For other question types, check givenAnswer
				return !question.givenAnswer;
			})
			.map((question) => question.id);

		const visibleQuestionIds = visibleQuestions.map((question) => question.id);

		// Check if there are any unanswered questions that are currently visible
		const hasUnansweredVisibleQuestions = questionIdsNotAnswered.some((id) =>
			visibleQuestionIds.includes(id)
		);

		return hasUnansweredVisibleQuestions;
	};

	return (
		<Button type="button" disabled={isSubmitBtnDisabled()} onClick={onClick}>
			Submit
		</Button>
	);
};

export default SubmitObservationsFormButton;
